import React from "react";
import { classNames } from "src/helpers/classNames";
import PreloaderIcon from "../PreloaderIcon";

const Preloader = ({ text = "Loading...", className = "" }) => {
  return (
    <div className={classNames("flex justify-center items-center gap-x-4 w-full h-[120px]", className)}>
      {/* <div className="spinner-border animate-spin inline-block w-14 h-14 border-[5px] rounded-full text-gray-300" role="status"></div> */}
      <PreloaderIcon height="h-14" widht="w-14" />
      <p className="m-0 text-lg text-gray-400">{text}</p>
    </div>
  );
};

export default Preloader;
